export default "__VITE_ASSET__BNA3QZsh__"